export default __webpack_public_path__ + "static/media/advisor-mudit-marda.2e8dc4d2.jpg";